/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";
import { TabProps } from "../Tab";

export const wrapperStyle = css`
	position: relative;
	display: flex;
	width: 100%;
`;

export const scrollWrapper = css`
	display: flex;
	width: 100%;
	flex-flow: column-reverse;
	overflow: hidden;
	overflow-x: scroll;
	white-space: nowrap;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const ulStyle = (
	theme: Theme,
	uiType: DesignStuff.Tabs.uiType,
	underLine: TabProps["underLine"],
	aspect: TabProps["aspect"]
) => css`
	padding: 0 16px 0;
	display: flex;
	flex: 1;
	border-bottom: ${uiType === "normal" && underLine ? "1px solid " + theme.colors.neutral_50_20 : "none"};
	flex-direction: ${aspect};
`;

export const lineStyle = (theme: Theme, state: { left: number; width: number }, lineThickness: number) => {
	return css`
		transition: all 0.3s ease-in-out;
		position: absolute;
		left: 0px;
		bottom: 0px;
		width: ${state.width}px;
		height: ${lineThickness}px;
		background: ${theme.colors.neutral_80_100};
		transform: translateX(${state.left}px);
	`;
};

export const tabItemStyle = (active: boolean, uiType: DesignStuff.Tabs.uiType, theme: Theme) => {
	const dotStyle =
		uiType === "dot"
			? css`
					content: "";
					position: absolute;
					right: -4px;
					top: 50%;
					transform: translateY(-50%);
					width: 4px;
					height: 4px;
					border-radius: 50%;
					background: ${theme.colors.neutral_60_100};
				`
			: css``;

	return css`
		padding: ${uiType === "normal" ? "6.5px 8px" : "0 8px"};
		margin: ${uiType === "normal" ? "0" : "0 4px 0 0"};
		color: ${active ? theme.colors.neutral_80_100 : theme.colors.neutral_80_60};
		cursor: pointer;
		position: relative;

		> * {
			opacity: ${active ? 1 : 0.6};
		}

		&:last-child {
			margin: 0;

			&::after {
				content: none;
			}
		}

		&::after {
			${dotStyle}
		}

		&:hover {
			opacity: 1;
		}
	`;
};
